import { Component, inject, input } from '@angular/core';
import { FtSectionsComponent } from './sections.component';

/**
 * Native-Angular port of the AngularJS `ftSection` directive. Renders its
 * transcluded content only when the parent `<ft-sections>`'s named section
 * is active. Must be a child (any depth) of `<ft-sections>` — uses
 * `@Host()` to grab the parent component instance.
 */
@Component({
    selector: 'ft-section',
    templateUrl: './section.component.html',
    standalone: false
})
export class FtSectionComponent {
    readonly name = input.required<string>();

    protected readonly parent = inject(FtSectionsComponent, { host: true });
}
